import React, { useEffect } from "react";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import "../style/about.scss";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <HeaderBar />

      <div className="mx-auto my-20 max-w-[800px] px-4 py-20">
        <p className="text-[30px]">Contact Us</p>
        <div className="py-8">
          <div className="grid gap-8 md:grid-cols-2">
            <div>
              <p className="mb-3 text-[13px] uppercase tracking-[2px]">
                First Name
              </p>

              <input
                type="text"
                className="w-full border border-gray-300 bg-transparent p-2 text-sm outline-none focus:border-black"
              />
            </div>

            <div>
              <p className="mb-3 text-[13px] uppercase tracking-[2px]">
                Last Name
              </p>

              <input
                type="text"
                className="w-full border border-gray-300 bg-transparent p-2 text-sm outline-none focus:border-black"
              />
            </div>
          </div>

          <div className="mt-2">
            <p className="mb-3 text-[13px] uppercase tracking-[2px]">Email</p>

            <input
              type="email"
              className="w-full border border-gray-300 bg-transparent p-2 text-sm outline-none focus:border-black"
            />
          </div>

          <div className="mt-2">
            <p className="mb-3 text-[13px] uppercase tracking-[2px]">Subject</p>

            <input
              type="text"
              className="w-full border border-gray-300 bg-transparent p-2 text-sm outline-none focus:border-black"
            />
          </div>

          <div className="mt-2">
            <p className="mb-3 text-[13px] uppercase tracking-[2px]">Message</p>

            <textarea
              rows={6}
              className="w-full resize-none border border-gray-300 bg-transparent px-4 py-4 text-sm outline-none focus:border-black"
            />
          </div>

          <button className="mt-10 flex w-[200px] items-center justify-center bg-btn p-2 text-sm uppercase tracking-[2px] text-white transition hover:opacity-85">
            send
          </button>
        </div>
      </div>

      <FooterBar />
    </React.Fragment>
  );
};

export default ContactUs;
